import React from 'react';
import AppSelect from './AppSelect';

/**
 * Form select — now powered by AppSelect (pure Tailwind, no TomSelect).
 * Public API unchanged: existing onChange((e) => e.target.value) call-sites
 * keep working via the event-adapter shim.
 */
const Select = React.forwardRef(
  (
    {
      label,
      required = false,
      options,
      placeholder,
      error = false,
      helperText,
      size, // eslint-disable-line no-unused-vars
      fullWidth = true,
      className = '',
      wrapperClassName = '',
      filterBarMatch = false,
      disabled = false,
      value,
      onChange,
      name,
      children,
      onSearchChange,
      loading = false,
    },
    _ref
  ) => {
    // Adapt direct value → event-style expected by existing callers
    const handleChange = (val) => {
      if (onChange) onChange({ target: { value: val, name } });
    };

    return (
      <AppSelect
        options={options}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        label={label}
        required={required}
        error={error}
        helperText={helperText}
        disabled={disabled}
        fullWidth={fullWidth}
        wrapperClassName={wrapperClassName}
        className={className}
        filterBarMatch={filterBarMatch}
        name={name}
        clearable={false}
        onSearchChange={onSearchChange}
        loading={loading}
      >
        {children}
      </AppSelect>
    );
  }
);

Select.displayName = 'Select';
export default Select;
